import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { Spinner } from "@/components/Elements";
import { MainLayout } from "@/components/Layout";
import { Authorization, Role } from "@/features/auth";
import { NotFound } from "@/features/error";
import { lazyImport } from "@/utils/lazyImport";

const { Dashboard } = lazyImport(() => import("@/features/misc"), "Dashboard");
const { Success } = lazyImport(() => import("@/features/misc"), "Success");
const { AuditsSearch } = lazyImport(
  () => import("@/features/auditReview"),
  "AuditsSearch",
);
const { HandHygieneRoutes } = lazyImport(
  () => import("@/features/handHygiene"),
  "HandHygieneRoutes",
);
const { FireDrillRoutes } = lazyImport(
  () => import("@/features/firedrill"),
  "FireDrillRoutes",
);
const { MedRoomChecklistRoutes } = lazyImport(
  () => import("@/features/medRoomChecklist"),
  "MedRoomChecklistRoutes",
);
const { EnvironmentalChecklistRoutes } = lazyImport(
  () => import("@/features/environmentalChecklist"),
  "EnvironmentalChecklistRoutes",
);

const { MoveInMoveOutRoutes } = lazyImport(
  () => import("@/features/environmentalChecklist"),
  "MoveInMoveOutRoutes",
);

const { ReportRoutes } = lazyImport(
  () => import("@/features/reports"),
  "ReportRoutes",
);

const { HudChecklistRoutes } = lazyImport(
  () => import("@/features/hudChecklist"),
  "HudChecklistRoutes",
);

const { UploadFileRoutes } = lazyImport(
  () => import("@/features/fileUpload"),
  "UploadFileRoutes",
);

const App = () => {
  return (
    <MainLayout>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "fire/*",
        element: <FireDrillRoutes />,
      },
      {
        path: "hygiene/*",
        element: <HandHygieneRoutes />,
      },
      {
        path: "medroom/*",
        element: <MedRoomChecklistRoutes />,
      },
      {
        path: "environment/*",
        element: <EnvironmentalChecklistRoutes />,
      },
      {
        path: "move/*",
        element: <MoveInMoveOutRoutes />,
      },
      {
        path: "hud/*",
        element: (
          <Authorization
            allowedRoles={[
              Role.EnvironmentalChecklistWriter,
              Role.EnvironmentalChecklistAdmin,
            ]}
          >
            <HudChecklistRoutes />,
          </Authorization>
        ),
      },
      {
        path: "success",
        element: <Success />,
      },
      {
        path: "search/*",
        element: <AuditsSearch />,
      },
      {
        path: "reports/*",
        element: <ReportRoutes />,
      },
      {
        path: "upload/*",
        element: <UploadFileRoutes />,
      },
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
